<template>
    <footer class="page-footer">
          <div class="container">
            <div class="row">
              <div class="col s12 m12 l12 center">
                <div class="footer-title">
                  Questions?
                </div>
                <div class="footer-contact">
                  <div class="row row-bottom-0">
                    <div class="col s12 m12 l12" >
                      Contact us at <a href="mailto:sales@zapy.io" style="color:white;">sales@zapy.io</a> | <br class="hide-on-med-and-up" />
                      <a class="hide-on-med-and-up" style="color:white;" href="tel:+6620263748">+66 2-026-3748</a><span class="hide-on-small-only">+66 2-026-3748</span>
                    </div>                     
                  </div>                
                </div>
              </div>
            </div>
          </div>
          <div >
            <div class="row">
              <div class="s12 m12 l12 center">
                 <hr class="footer-line"/>
              </div>
            </div>
          </div>
          
          <div class="footer-copyright">
            <div class="container center">
            © 2018 Zapy All Rights Reserved           
            </div>
          </div>
        </footer>
</template>
<script>
export default {
    name: 'Footer'
}
</script>

